module.exports = {
      id: "vikatan-play-usage",
      viewBox: "0 0 27.8 28.8",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#vikatan-play",
      toString: function () {
        return this.url;
      }
    }